import Vue from 'vue'
import Router from 'vue-router'
import debug from 'debug'

import store from '../store'
import * as types from '../store/mutation-types'

const d = debug('Focuxy.router')
const getComponent = name => r => require(['../../src/components/'], cs => r(cs[name]))

Vue.use(Router)

const requireAuthComponents = []

const routes = [
  { name: 'Login', title: '登录' },
  { name: 'Downloads', title: '下载中心' },
  { name: 'Home', title: '首页', path: '/' },
  { name: 'ChangeLog', title: '文档中心', path: '/changelog/:version' },
  { name: 'Message', title: '系统消息', path: '/:code/:index' }
].map(({ name, path, title, icon, subtitle }) => ({
  path: path || `/${name.toLowerCase()}`,
  name,
  component: getComponent(name),
  meta: {
    title,
    icon,
    subtitle,
    requireAuth: requireAuthComponents.indexOf(name) >= 0
  }
}))
d.enabled && d('all routes: %o', routes)
const router = new Router({
  mode: 'history',
  routes
})

store.commit(types.LOGIN.CHECK)

router.beforeEach((to, from, next) => {
  d('to: %s', to.fullPath)
  document.title = to.meta.title || to.name
  d.enabled && d(`change title to ${document.title}`)
  if (to.matched.length > 0 && to.matched.every(r => !r.meta.requireAuth)) {
    d('no need to login')
    return next()
  }
  if (store.state.user.token && store.state.user.payload) {
    d('user has logged in')
    return next()
  }
  d('redirect to Login')
  next({
    name: 'Login'
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js